export const arrowSortDown = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M3 6l3 3l3 -3" />
    <path d="M6 6v12" />
    <path d="M14 15l3 3l3 -3" />
    <path d="M17 6v12" />
  </svg>
);
